(() => {
  const root = document.querySelector('#PrivateViewing');
  if (!root || !root.querySelector('[data-variants]')) return;
  const variants = JSON.parse(root.querySelector('[data-variants]').textContent);
  const colourMedia = JSON.parse(root.querySelector('[data-colour-media]')?.textContent || '[]');
  const labels = JSON.parse(root.querySelector('[data-labels]').textContent);
  const selectors = [...root.querySelectorAll('[data-option]')];
  const price = root.querySelector('[data-price]');
  const availability = root.querySelector('[data-availability]');
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
  const track = (action, detail = {}) => {
    if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() !== true) return;
    window.Shopify?.analytics?.publish?.('private_viewing_engagement', {viewing: root.dataset.viewingId, action, ...detail});
  };
  let selectedVariant;
  const metalSelect = selectors.find(s => /metal/i.test(s.dataset.optionName));
  const splitColour = !selectors.some(s => /colou?r/i.test(s.dataset.optionName)) && metalSelect && [...metalSelect.options].some(o => /rose/i.test(o.value)) && [...metalSelect.options].some(o => /white/i.test(o.value));
  let selectedFinish = metalSelect && /rose/i.test(metalSelect.value) ? 'Rose Gold' : 'White Gold';
  if (splitColour) {
    const group = document.createElement('fieldset'); group.className = 'pv-config-group';
    const legend = document.createElement('legend'); legend.textContent = 'Colour'; group.append(legend);
    ['White Gold', 'Rose Gold'].forEach(finish => {
      const label = document.createElement('label'); label.className = 'pv-choice';
      const input = document.createElement('input'); input.type = 'radio'; input.name = 'pv-finish'; input.value = finish; input.checked = finish === selectedFinish;
      const text = document.createElement('span'); text.textContent = finish; label.append(input, text); group.append(label);
      input.addEventListener('change', () => { selectedFinish = finish; metalSelect.dispatchEvent(new Event('change', {bubbles:true})); });
    });
    root.querySelector('.pv-options').prepend(group);
  }
  function updateOptions() {
    const values = [];
    selectors.forEach((select, index) => {
      const valid = new Set(variants.filter(v => values.every((x,i) => v.options[i] === x) && (!splitColour || select !== metalSelect || /rose/i.test(v.options[index]) === (selectedFinish === 'Rose Gold'))).map(v => v.options[index]));
      [...select.options].forEach(option => { option.disabled = !valid.has(option.value); option.hidden = option.disabled; });
      if (!valid.has(select.value)) select.value = [...valid][0];
      values.push(select.value);
    });
    const variant = variants.find(v => v.options.every((value,i) => value === values[i]));
    if (!variant) return;
    selectedVariant = variant;
    price.textContent = variant.price;
    const colourIndex = selectors.findIndex(s => /colou?r/i.test(s.dataset.optionName));
    if (colourIndex >= 0) {
      const colour = values[colourIndex];
      selectors.filter(s => /metal/i.test(s.dataset.optionName)).forEach(s => [...s.options].forEach(o => {
        o.textContent = o.value.replace(' Diamonds','').replace('14k Gold', `14k ${colour}`).replace('925 Silver', /rose/i.test(colour) ? 'Rose-plated 925 silver' : '925 silver');
      }));
    }
    const acquisitionImage = root.querySelector('.pv-acquire-image img');
    const finish = colourIndex >= 0 ? values[colourIndex] : (splitColour ? selectedFinish : '');
    const matchingMedia = finish ? colourMedia.filter(m => new RegExp(/rose/i.test(finish) ? 'rose' : 'white', 'i').test((m.alt || '') + ' ' + m.url)) : [];
    const selectedImage = matchingMedia[0]?.url || variant.image;
    if (selectedImage && acquisitionImage) {acquisitionImage.removeAttribute('srcset'); acquisitionImage.src = selectedImage; acquisitionImage.alt = `${root.dataset.title} — ${variant.title}`;}
    availability.textContent = variant.available ? '' : labels.unavailable;
    const link = new URL(root.dataset.url);
    link.searchParams.set('variant', variant.id);
    const message = `${root.dataset.message}\n${variant.title}\n${variant.price}\n${link.href}`;
    root.querySelectorAll('[data-enquire]').forEach(a => a.href = `https://wa.me/${root.dataset.phone.replace(/\D/g,'')}?text=${encodeURIComponent(message)}`);
    root.querySelectorAll('[data-selected-summary]').forEach(el => el.textContent = `${root.dataset.title} — ${variant.title} — ${variant.price}`);
    root.querySelectorAll('[data-contact="email"]').forEach(a => a.href = `mailto:${a.dataset.email}?subject=${encodeURIComponent(root.dataset.title)}&body=${encodeURIComponent(message)}`);
  }
  selectors.forEach(select => select.addEventListener('change',() => {updateOptions(); track('variant_selection',{variant_id:selectedVariant?.id});}));
  const visualGroups = selectors.map((select,index) => {
    const field = document.createElement('fieldset');
    field.className='pv-config-group';
    if(/length|size/i.test(select.dataset.optionName)) field.classList.add('pv-config-length');
    const legend=document.createElement('legend');legend.textContent=select.dataset.optionName;field.append(legend);
    [...select.options].forEach(option=>{
      const label=document.createElement('label');label.className='pv-choice';
      const radio=document.createElement('input');radio.type='radio';radio.name=`pv-choice-${index}`;radio.value=option.value;
      const text=document.createElement('span');text.textContent=option.textContent;
      label.append(radio,text);field.append(label);
      radio.addEventListener('change',()=>{if(radio.checked){select.value=radio.value;select.dispatchEvent(new Event('change',{bubbles:true}));}});
    });
    select.closest('.pv-option').after(field);
    select.closest('.pv-option').hidden=true;
    return {select,field};
  });
  function syncVisualChoices(){
    visualGroups.forEach(({select,field})=>field.querySelectorAll('input').forEach(radio=>{
      const option=[...select.options].find(o=>o.value===radio.value);
      radio.checked=select.value===radio.value;radio.disabled=option.disabled;
      radio.closest('label').hidden=option.hidden;
      radio.nextElementSibling.textContent=option.textContent;
    }));
  }
  selectors.forEach(select=>select.addEventListener('change',syncVisualChoices));
  updateOptions();syncVisualChoices();
  let openPanel=null, returnFocus=null;
  const panels=[...root.querySelectorAll('.pv-panel')];
  panels.forEach(panel=>{panel.hidden=true;panel.setAttribute('role','dialog');panel.setAttribute('aria-modal','true');});
  function closePanel(){
    if(!openPanel)return;
    openPanel.hidden=true;openPanel.classList.remove('is-open');
    [...root.children].forEach(el=>{el.inert=false;});
    document.documentElement.classList.remove('pv-modal-open');
    openPanel=null;returnFocus?.focus({preventScroll:true});
  }
  root.querySelectorAll('[data-dialog-open]').forEach(trigger=>trigger.addEventListener('click',event=>{
    const panel=panels.find(p=>p.id===trigger.dataset.dialogOpen);if(!panel)return;
    event.preventDefault();returnFocus=trigger;openPanel=panel;
    [...root.children].forEach(el=>{el.inert=el!==panel;});
    panel.hidden=false;panel.classList.add('is-open');
    document.documentElement.classList.add('pv-modal-open');
    panel.querySelector('[data-dialog-close]')?.focus({preventScroll:true});
    if(panel.id==='pv-advisor')track('advisor_options_open',{variant_id:selectedVariant?.id});
  }));
  root.querySelectorAll('[data-dialog-close]').forEach(a=>a.addEventListener('click',event=>{event.preventDefault();closePanel();}));
  document.addEventListener('keydown',event=>{
    if(!openPanel)return;
    if(event.key==='Escape'){event.preventDefault();closePanel();return;}
    if(event.key!=='Tab')return;
    const elements=[...openPanel.querySelectorAll('a[href],button,input,select,summary,[tabindex="0"]')].filter(el=>!el.disabled&&el.getClientRects().length);
    const first=elements[0],last=elements.at(-1);
    if(event.shiftKey&&document.activeElement===first){event.preventDefault();last?.focus();}
    else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first?.focus();}
  });
  let viewed = false;
  function view() {
    if (!viewed && window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true) {track('presentation_start',{template:'private-viewing'}); viewed = true;}
  }
  view();
  document.addEventListener('visitorConsentCollected',view);
  if (window.Shopify?.loadFeatures) window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],view);
  const depths = new Set();
  let frame = false;
  addEventListener('scroll',() => {
    if(frame) return;
    frame = true;
    requestAnimationFrame(() => {
      frame = false;
      const depth = (scrollY + innerHeight) / document.documentElement.scrollHeight * 100;
      [25,50,75,100].forEach(n => {if(depth >= n && !depths.has(n) && window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true){depths.add(n);track('scroll',{depth:n});}});
    });
  },{passive:true});
  root.querySelectorAll('[data-contact]').forEach(a => a.addEventListener('click',() => track('enquiry_intent',{channel:a.dataset.contact,variant_id:selectedVariant?.id}))); 
  const film = root.querySelector('.pv-opening-film');
  if (film) {
    film.controls=false;
    film.tabIndex=0;
    film.setAttribute('role','button');
    const updateControl=()=>film.setAttribute('aria-label',film.paused?labels.playFilm:labels.pauseFilm);
    film.addEventListener('play',updateControl);
    film.addEventListener('pause',updateControl);
    let userPaused=false;
    const toggleFilm=()=>{if(film.paused){userPaused=false;film.muted=true;film.play().catch(()=>{});}else {userPaused=true;film.pause();}};
    film.addEventListener('click',toggleFilm);
    film.addEventListener('keydown',event=>{if(event.key==='Enter'||event.key===' '){event.preventDefault();toggleFilm();}});
    updateControl();
    const startFilm = () => {
      if (!reducedMotion.matches && !navigator.connection?.saveData) {film.muted = true; film.play().catch(() => {});} else film.pause();
    };
    film.addEventListener('error',() => {film.hidden = true;});
    startFilm();
    reducedMotion.addEventListener('change',startFilm);
    if ('IntersectionObserver' in window) new IntersectionObserver(entries => {entries.forEach(entry => {if(!entry.isIntersecting) film.pause(); else if(!userPaused) startFilm();});},{threshold:0}).observe(film);
  }
  const scenes = [...root.querySelectorAll('[data-scene]')];
  const nav = root.querySelector('.pv-scene-nav');
  const picker = root.querySelector('[data-scene-select]');
  const previous = root.querySelector('[data-previous]');
  const next = root.querySelector('[data-next]');
  const scrollMode = root.querySelector('[data-scroll-mode]');
  const header = root.querySelector('.pv-header');
  let active = 0;
  let free = false;
  if (scenes.length && nav && picker) {
    scenes.forEach((scene,index) => {
      const option = document.createElement('option');
      option.value = String(index);
      option.textContent = `${String(index+1).padStart(2,'0')} — ${scene.dataset.sceneLabel.replace(/^\d+\s*\/\s*/, '')}`;
      picker.append(option);
    });
    root.querySelector('.pv-scene-total').textContent = `— ${String(scenes.length).padStart(2,'0')}`;
    nav.hidden = false;
    if(scrollMode) scrollMode.hidden = false;
    const recordedScenes=new Set();
    function activate(index) {
      if(!recordedScenes.has(index) && window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true){recordedScenes.add(index);track('scene_reached',{scene:index+1,label:scenes[index].dataset.sceneLabel});if(scenes[index].id==='pv-acquire')track('acquisition_reached');}
      active = index;
      picker.value = String(index);
      picker.parentElement.dataset.current = String(index+1).padStart(2,'0');
      previous.disabled = index === 0;
      next.disabled = index === scenes.length-1;
      const dark = scenes[index].classList.contains('pv-dark');
      [header,nav,scrollMode].forEach(el => el?.classList.toggle('is-dark',dark));
      scenes[index].classList.add('is-seen');
    }
    function go(index, focus = false) {
      const scene = scenes[Math.max(0,Math.min(scenes.length-1,index))];
      scene.scrollIntoView({behavior:reducedMotion.matches || free?'instant':'smooth',block:'start'});
      if(focus) scene.focus({preventScroll:true});
    }
    previous.addEventListener('click',() => go(active-1));
    next.addEventListener('click',() => go(active+1));
    picker.addEventListener('change',() => go(Number(picker.value)));
    scrollMode?.addEventListener('click',() => {
      free = !free;
      document.documentElement.classList.toggle('pv-free-scroll',free);
      scrollMode.setAttribute('aria-pressed',String(free));
      scrollMode.textContent = free?labels.sceneScroll:labels.freeScroll;
    });
    root.querySelectorAll('a[href^="#"]').forEach(a => a.addEventListener('click',event => {
      const index = scenes.findIndex(scene => '#'+scene.id === a.getAttribute('href'));
      if(index < 0) return;
      event.preventDefault();go(index,true);
      root.querySelector('.pv-menu')?.removeAttribute('open');
    }));
    let sceneFrame = false;
    function currentScene() {
      sceneFrame = false;
      const line = innerHeight * .42;
      const index = scenes.findIndex(s => {const r=s.getBoundingClientRect();return r.top<=line && r.bottom>line;});
      if(index >= 0) activate(index);
    }
    addEventListener('scroll',() => {if(!sceneFrame){sceneFrame=true;requestAnimationFrame(currentScene);}},{passive:true});
    addEventListener('resize',currentScene,{passive:true});
    document.addEventListener('keydown',event => {
      if(openPanel || free || event.altKey || event.ctrlKey || event.metaKey || event.shiftKey || event.target.closest?.('input,select,textarea,button,a,video,[contenteditable="true"]')) return;
      const rect=scenes[active].getBoundingClientRect();
      if(rect.height > innerHeight+4) return;
      if(event.key==='PageDown' || event.key==='PageUp') {event.preventDefault();go(active+(event.key==='PageDown'?1:-1),true);}
    });
    currentScene();
    if('IntersectionObserver' in window) {
      if(!reducedMotion.matches) root.classList.add('pv-motion');
      new IntersectionObserver(entries => entries.forEach(entry => {
        if(entry.isIntersecting) entry.target.classList.add('is-seen');
      }),{threshold:0.16}).observe(scenes[0]);
      const reveal = new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('is-seen');reveal.unobserve(entry.target);}}),{threshold:0.16});
      scenes.slice(1).forEach(scene=>reveal.observe(scene));
    }
  }
  root.querySelectorAll('[data-perspective]').forEach(button => {
    const scene=button.closest('.pv-pair');
    scene.classList.add('has-perspective');
    button.hidden=false;
    button.dataset.perspectiveNumber='01 / 02';
    const secondary=scene.querySelector('.pv-second-media');
    secondary.setAttribute('aria-hidden','true');
    button.addEventListener('click',() => {
      const second=scene.classList.toggle('is-second');
      button.setAttribute('aria-pressed',String(second));
      secondary.setAttribute('aria-hidden',String(!second));
      button.dataset.perspectiveNumber=second?'02 / 02':'01 / 02';
      scene.querySelector('.pv-chapter-media').setAttribute('aria-hidden',String(second));
    });
  });
  async function personalise() {
    const invitation = window.ilPrivateInvitation;
    delete window.ilPrivateInvitation;
    if(root.dataset.personalisation !== 'true' || !invitation || invitation.length > 2000) return;
    try {
      const raw = Uint8Array.from(atob(invitation.replace(/-/g,'+').replace(/_/g,'/')),c => c.charCodeAt(0));
      const key = await crypto.subtle.importKey('raw',raw.slice(0,32),'AES-GCM',false,['decrypt']);
      const clear = await crypto.subtle.decrypt({name:'AES-GCM',iv:raw.slice(32,44)},key,raw.slice(44));
      const data = JSON.parse(new TextDecoder().decode(clear));
      if(typeof data.name !== 'string' || data.name.length > 50 || data.exp < Date.now() || data.path !== location.pathname) return;
      root.querySelector('[data-greeting]').textContent = labels.personal.replace('[name]',data.name);
      root.querySelector('[data-greeting]').hidden=false;
    } catch (_) {}
  }
  personalise();
})();
